import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { addFilesToQueue } from '../redux/actions/fileUpload';
import uploadManager from '../services/UploadManager';
import { errorToast } from '../utils/toast';
import { fileUploadError } from '../utils/constant';
import { getPresignedUrl, buildFilesWithMetadata, buildUploadTasks } from '../utils/uploadUtils';
import { RECORD_TYPE_PURPOSE } from '@demandproai/shared';

const useUploadQueue = (caseId) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);

    const queueFiles = useCallback(async ({ files, caseRecordType, purpose = null, callback = null, hasInlineProgress = false }) => {
        setIsLoading(true);
        try {
            const presignedData = await Promise.all(
                files.map((fileData) =>
                    getPresignedUrl({
                        file: fileData.file,
                        fileName: fileData.name || fileData.file.name,
                        caseId,
                        metaData: fileData.metaData || {},
                        purpose: purpose??RECORD_TYPE_PURPOSE[caseRecordType],
                    })
                )
            );

            const filesWithMetadata = buildFilesWithMetadata(files, presignedData);
            const uploadTasks = buildUploadTasks({ files, presignedData, caseId, caseRecordType, callback, hasInlineProgress });

            dispatch(addFilesToQueue(uploadTasks));
            uploadManager.processQueue();

            setIsLoading(false);
            return { filesWithMetadata, uploadTasks };
        } catch (error) {
            setIsLoading(false);
            errorToast(fileUploadError);
            console.error('Error queuing files for upload:', error);
            throw error;
        }
    }, [caseId, dispatch]);

    return { isLoading, queueFiles };
};

export default useUploadQueue;
